// extracted by mini-css-extract-plugin
module.exports = {"Burger":"Burger_Burger_3K4F-"};